import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { Routes } from '@/constants';
import { lumiqWhiteIcon } from '@/images';
import { uiActions } from '@/store';

export const NavbarLogo = () => {
  const dispatch = useDispatch();

  return (
    <Box
      component={Link}
      to={Routes.DISCOVER}
      onClick={() => dispatch(uiActions.closeSidebarDrawer())}
      aria-label="Home"
      sx={styles.logoContainer}>
      <Box
        component="img"
        src={lumiqWhiteIcon}
        sx={{
          width: 38,
          height: 38,
        }}
      />
    </Box>
  );
};

const styles = {
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    ml: { xs: 0, md: 3 },
    color: 'white',
    width: 100,
    height: 26,
    '&:hover': {
      cursor: 'pointer',
    },
  },
};
